export default class Observer {
  constructor() {
    this.observers = [];
  }
  subscribe(type, callback, scope) {
    scope = scope || window;
    this.observers.push({
      type: type,
      callback: callback.bind(scope),
    })
    return this;
  }
  publish(type, data) {
    const types = Array.isArray(type) ? type : [type];
    this.observers.forEach(function(obs) {
      types.forEach(function(t) {
        if(obs.type === t) {
          obs.callback(data)
        }
      })
    });
    return this;
  }
  unsubscribe(type, callback) {
    this.observers = this.observers.filter(function(sub) {
      return (type && sub.type !== type) && (callback && sub.callback !== callback)
    });
    return this;
  }
}